// Arena builders by map (§12.5).
import { MapId } from '@shared/ids';
import { buildCake } from './cake';
import { buildLobby, buildPodium } from './lobby';
import { buildPinball } from './pinball';
import { buildSpin } from './spin';
import { buildTeacup } from './teacup';
import type { Arena, ArenaKit } from './types';

export function buildArena(kit: ArenaKit): Arena {
  switch (kit.mapId) {
    case MapId.LOBBY: return buildLobby(kit);
    case MapId.PODIUM: return buildPodium(kit);
    case MapId.TEACUP: return buildTeacup(kit);
    case MapId.PINBALL: return buildPinball(kit);
    case MapId.CAKE: return buildCake(kit);
    case MapId.SPIN: return buildSpin(kit);
  }
}
